/**
 * Liberações (MedicationDispense) vinculadas a uma transação.
 * Match somente por extension transaction-id.
 * @module transactionReleaseLookup
 */

import type { MedicationDispense } from "fhir/r5";
import {
  getDispenseQuantity,
  getDispenseTransactionId,
  isActivePurchaseDispense,
  isDispenseReleaseCurrentlyValid,
  purchaseReleaseMemory,
} from "src-next/modules/patient-supporting-documents/purchase-release";

function listTransactionDispenses(
  patientKey: string,
  transactionId: string,
): MedicationDispense[] {
  const key = patientKey.trim();
  const txId = transactionId.trim();
  if (!key || !txId || txId.startsWith("pending:")) return [];

  const batches = purchaseReleaseMemory.get(key) ?? [];
  return batches.flatMap((batch) =>
    batch.dispenses.filter(
      (dispense) =>
        isActivePurchaseDispense(dispense) &&
        getDispenseTransactionId(dispense) === txId,
    ),
  );
}

/** Liberação ainda com saldo (quantity > 0) e validade. */
export function peekPatientReleaseForTransaction(
  patientKey: string,
  transactionId: string,
): boolean {
  return listTransactionDispenses(patientKey, transactionId).some(
    (dispense) =>
      isDispenseReleaseCurrentlyValid(dispense) &&
      getDispenseQuantity(dispense) > 0,
  );
}

/**
 * Compra concluída: a transação tem MedicationDispense e o saldo chegou a zero.
 * Não consulta WooCommerce.
 */
export function peekTransactionPurchaseCompleted(
  patientKey: string,
  transactionId: string,
): boolean {
  const matching = listTransactionDispenses(patientKey, transactionId);
  if (!matching.length) return false;
  return matching.every((dispense) => getDispenseQuantity(dispense) <= 0);
}
